import React from 'react';
import TableStructure from './tableStructure';

const ExperimentalLoad = () => {
    
    return <><TableStructure/></>;
};


export default ExperimentalLoad;